import { Side } from '../../perio-exam-screen/services/perio-exam/models';

export enum QuadrantId {
  UpperRight = 'upper-right',
  UpperLeft = 'upper-left',
  LowerLeft = 'lower-left',
  LowerRight = 'lower-right',
}

export const UPPER_RIGHT_START = 1;
export const UPPER_RIGHT_END = 8;
export const UPPER_LEFT_START = 9;
export const UPPER_LEFT_END = 16;
export const LOWER_LEFT_START = 17;
export const LOWER_LEFT_END = 24;
export const LOWER_RIGHT_START = 25;
export const LOWER_RIGHT_END = 32;

export const QUADRANT_DEFS = [
  { id: QuadrantId.UpperRight, range: [UPPER_RIGHT_START, UPPER_RIGHT_END] },
  { id: QuadrantId.UpperLeft, range: [UPPER_LEFT_START, UPPER_LEFT_END] },
  { id: QuadrantId.LowerLeft, range: [LOWER_RIGHT_START, LOWER_RIGHT_END] },
  { id: QuadrantId.LowerRight, range: [LOWER_LEFT_START, LOWER_LEFT_END] },
];

export enum SideId {
  UpperBuccal = 'upper-buccal',
  UpperLingual = 'upper-lingual',
  LowerBuccal = 'lower-buccal',
  LowerLingual = 'lower-lingual',
}

export const SideGroup: Record<Side, SideId[]> = {
  [Side.Lingual]: [SideId.LowerLingual, SideId.UpperLingual],
  [Side.Buccal]: [SideId.LowerBuccal, SideId.LowerLingual],
};

export const SIDE_ID_DEFS = [
  { id: SideId.UpperBuccal, jaw: 'upper', side: 'buccal' },
  { id: SideId.UpperLingual, jaw: 'upper', side: 'lingual' },
  { id: SideId.LowerLingual, jaw: 'lower', side: 'lingual' },
  { id: SideId.LowerBuccal, jaw: 'lower', side: 'buccal' },
];
